import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;    // "order" | "customer" | "date" | "product" | "sales"
  doc_type?: string;       // "sample" | "bulk" | "all" | "inventory"
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  customer_from?: string;
  customer_to?: string;
  product_from?: string;
  product_to?: string;
  delivery_no_from?: string;
  delivery_no_to?: string;
  sales_from?: string;
  sales_to?: string;
  perf_customer_from?: string;
  perf_customer_to?: string;
}

export interface ReportRow {
  delivery_no: string;
  customer_code: string;
  customer_name: string;
  delivery_date: string;
  product_code: string;
  color_code: string;
  color_name: string;
  currency: string;
  net_amount: number;
  tax_amount: number;
  total_amount: number;
  unit: string;
  unit_price: number;
  qty: number;
  amount: number;
  nt_amount: number;
  sales_code: string;
  sales_name: string;
  doc_source: string;
}

export interface GroupCount {
  code: string;
  name: string;
  count: number;
}

export interface UnitSummary {
  unit: string;
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface CurrencySummary {
  currency: string;
  total_amt: number;
  total_nt_amt: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  group_counts: GroupCount[];
  unit_summary: UnitSummary[];
  currency_summary: CurrencySummary[];
  message?: string;
}

export const c304Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/c304/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/c304/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
